import { useParams } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'
import ActionAnimation from 'components/ActionAnimation'
import CastingChat from './components/CastingChat'
import CastingRoles from './components/CastingRoles/CastingRoles'
import DecisionActions from './components/DecisionActions'
import ContentActions from './components/ContentActions'
import Tutorial from './components/Tutorial'
import { useCastingStore, useUserStore } from 'store'
import { CUSTOMER_ROLE } from 'types/user'
import s from './index.module.scss'
import { PROJECT_ACCESS } from 'types/enums'

const CastingOverlay = (): JSX.Element => {
	const { roleId, userId } = useParams()
	const director = useUserStore(
		useShallow(
			(state) =>
				state.user?.CustomerRole?.toLowerCase() ===
				CUSTOMER_ROLE.CASTING_DIRECTOR,
		),
	)
	const [showTutorial, access] = useCastingStore(
		useShallow((state) => [state.showTutorial, state.projectAccess]),
	)

	return (
		<div className={s.container} id="casting-overlay-container">
			<Tutorial />
			{showTutorial ? null : (
				<>
					<CastingRoles />
					<ActionAnimation />
					<CastingChat />
					{/* <Back /> */}
					{(director || access === PROJECT_ACCESS.FULLACCESS) &&
					roleId &&
					userId ? (
						<>
							<ContentActions />
							<DecisionActions />
						</>
					) : null}
				</>
			)}
		</div>
	)
}

export default CastingOverlay
